import axios from 'axios';
import { AuthService } from '../apiServices';
import TabStorage from '../../helper/TabStorage';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SLATTERY_API_URL,
    timeout: 10000,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        "InternalApiKey": "123",
    },
});

// axiosInstance.interceptors.request.use(
//     async (config) => {
//         const userData = localStorage.getItem('user');
//         let token = null;
//         if (userData) {
//             try {
//                 token = JSON.parse(userData);
//             } catch (e) {
//                 console.error("Invalid JSON in localStorage:", e);
//             }
//         }
//         if (token?.token) {
//             config.headers.Authorization = `Bearer ${token.token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// axiosInstance.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         if (error.response?.status === 401) {
//             await handleUnauthorizedError();
//         }
//         return Promise.reject(error);
//     }
// );

const handleUnauthorizedError = async () => {
    try {
        const response = await AuthService.generateToken();
        if (response?.data?.isSuccess) {
            TabStorage.setItem("user", response.data.payload);
        }
    } catch (error) {
        console.error("Error handling generateToken error:", error);
    }
};

export default axiosInstance;
